class BatchingConfirmationModalComponent {
  constructor($scope) {
    Object.assign(this, {
      $scope,
      count: $scope.ngDialogData.count
    });
  }

  shouldSendForBatching(approve = false) {
    this.$scope.closeThisDialog({
      approve,
    });
  }
}
BatchingConfirmationModalComponent.$inject = ["$scope"];
angular.module('pims').controller('BatchingConfirmationModalComponent', BatchingConfirmationModalComponent);
